import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { addRemark } from 'api/auth.api';

export const useAddRemark = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addRemark,

    onSuccess: (res) => {
      toast({
        title: 'Remark added',
        description: res?.data?.message || 'Remark added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to add remark',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
